import React from 'react';
import injectSheet from 'react-jss';
const styles = {
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },

        "100%": {
            transform: "rotate(360deg)"
        }
    },
    spinner: {
        border: "solid #f3f3f3", /* Light grey */
        borderTop: "solid #3498db", /* Blue */
        borderWidth: props => (props.width / 5),
        borderRadius: "50%",
        width: props => props.width,
        height: props => props.width,
        display: "inline-block",
        margin: "0 auto",
        paddingTop: "5px",
        animation: "$spin 2s linear infinite"
    }
};

const Spinner = injectSheet(styles)(({ classes }) =>
    <div className={classes.spinner}></div>
);

export default Spinner;